// extracted by mini-css-extract-plugin
export default {"content":"PackageItems_content__XDTP5","header":"PackageItems_header__N2ZMW","ulParent":"PackageItems_ulParent__5wy3L","selected":"PackageItems_selected__e2OtX"};